import { render } from "./Package.vue?vue&type=template&id=d9dd3190&scoped=true"
import script from "./Package.vue?vue&type=script&lang=js"
export * from "./Package.vue?vue&type=script&lang=js"

import "./Package.vue?vue&type=style&index=0&id=d9dd3190&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d9dd3190"

export default script